import * as React from "react";
import { Row, Space, Text } from "@stenajs-webui/core";
import { Icon, InputSpinner, stenaCheck } from "@stenajs-webui/elements";
import { Window } from "@stenajs-webui/modal";
import { CopyHeadAgreementFormModel } from "../../model/CopyHeadAgreementFormModel";
import { HeadAgreement } from "../../types";
import { IndentValues } from "@/lib/utils/IndentValues";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import { CopyHeadAgreementTargetCustomerQuery } from "@/gql/graphql";
import { CopyHaFromOtherCustomerResultPane } from "./CopyHaFromOtherCustomerResultPane";

interface Props {
  open: boolean;
  onRequestClose: Function;
  success: boolean;
  loading: boolean;
  copyFromHeadAgreement: HeadAgreement;
  copyToHeadAgreement:
    | CopyHeadAgreementTargetCustomerQuery["productPrice"]["headAgreement"]["byId"]
    | undefined;
  copyToCustomerPath: string;
  formModel: CopyHeadAgreementFormModel;
}

export const CopyHaFromOtherCustomerModal: React.FC<Props> = ({
  open,
  onRequestClose,
  success,
  loading,
  copyFromHeadAgreement,
  copyToHeadAgreement,
  copyToCustomerPath,
  formModel,
}) => {
  return (
    <Window
      width={"100%"}
      isOpen={open}
      shouldCloseOnOverlayClick={false}
      onRequestClose={() => {
        onRequestClose();
      }}
      indent={IndentValues.TWENTYFOUR}
      spacing={SpacingValues.TWENTYFOUR}
      header={
        success ? (
          <Row alignItems={"center"}>
            <Icon icon={stenaCheck} />
            <Space num={2} />
            <Text size="large">Copy successful</Text>
          </Row>
        ) : loading ? (
          <Row alignItems={"center"}>
            <InputSpinner size={"small"} />
            <Space num={2} />
            <Text size="large">Copying agreements</Text>
          </Row>
        ) : null
      }
    >
      <CopyHaFromOtherCustomerResultPane
        loading={loading}
        success={success}
        copyToCustomerPath={copyToCustomerPath}
        copyFromHeadAgreement={copyFromHeadAgreement}
        copyToHeadAgreement={copyToHeadAgreement}
        formModel={formModel}
      />
    </Window>
  );
};
